import { axios, handleError } from '../axios';

export const deleteGCategory = (id) => {
  return new Promise((resolve) => {
    const formData = new FormData();
    formData.append('id', id);

    axios
      .post('admin/g_category/delete', formData)
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
